import { useState, useEffect } from 'react';

const BASE = '/api';
function api(method, path, body) {
  const token = localStorage.getItem('ozon_token');
  return fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async r => {
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.error || r.statusText);
    return d;
  });
}

export default function WarehouseMap() {
  const [products,   setProducts]   = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [mapping,    setMapping]    = useState({}); // offer_id → warehouse_id
  const [saving,     setSaving]     = useState({});
  const [search,     setSearch]     = useState('');
  const [loading,    setLoading]    = useState(true);

  useEffect(() => {
    Promise.all([
      api('GET', '/products?limit=2000').catch(() => ({ products: [] })),
      api('GET', '/ozon-stock/warehouses').catch(() => []),
      api('GET', '/product-warehouse').catch(() => []),
    ]).then(([prodRes, whList, mapList]) => {
      setProducts(prodRes.products || prodRes || []);
      setWarehouses(whList);
      const m = {};
      mapList.forEach(r => { m[r.offer_id] = String(r.warehouse_id); });
      setMapping(m);
    }).finally(() => setLoading(false));
  }, []);

  async function save(offer_id, warehouse_id) {
    const wh = warehouses.find(w => String(w.warehouse_id) === warehouse_id);
    setSaving(s => ({ ...s, [offer_id]: true }));
    try {
      if (!warehouse_id) {
        await api('DELETE', `/product-warehouse/${encodeURIComponent(offer_id)}`);
        setMapping(m => { const n = { ...m }; delete n[offer_id]; return n; });
      } else {
        await api('POST', '/product-warehouse', { offer_id, warehouse_id: parseInt(warehouse_id), warehouse_name: wh?.name });
        setMapping(m => ({ ...m, [offer_id]: warehouse_id }));
      }
    } catch (e) { alert(e.message); }
    finally { setSaving(s => ({ ...s, [offer_id]: false })); }
  }

  const filtered = products.filter(p =>
    !search || p.offer_id?.toLowerCase().includes(search.toLowerCase()) || p.name?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="p-6 text-gray-400 text-sm">Yükleniyor...</div>;

  return (
    <div className="p-4 md:p-6">
      <div className="mb-4 flex items-center gap-3">
        <input
          value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Ürün ara..."
          className="border border-gray-200 rounded-xl px-3 py-2 text-sm w-64 focus:outline-none focus:border-blue-400"
        />
        <span className="text-xs text-gray-400">{Object.keys(mapping).length} ürün eşleştirildi</span>
      </div>

      {warehouses.length === 0 && (
        <div className="text-amber-600 text-sm mb-4">Aktif depo bulunamadı — Ozon panelinden depo oluşturun.</div>
      )}

      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100">
              <th className="text-left px-4 py-3 font-semibold text-gray-600 w-48">Offer ID</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600">Ürün Adı</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600 w-64">Depo</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p, i) => (
              <tr key={p.offer_id} className={`border-b border-gray-50 ${i % 2 === 0 ? '' : 'bg-gray-50/40'}`}>
                <td className="px-4 py-2.5 font-mono text-xs text-gray-500 truncate max-w-[180px]">{p.offer_id}</td>
                <td className="px-4 py-2.5 text-gray-700 truncate max-w-[300px]">{p.name || '—'}</td>
                <td className="px-4 py-2.5">
                  <select
                    value={mapping[p.offer_id] || ''}
                    onChange={e => save(p.offer_id, e.target.value)}
                    disabled={saving[p.offer_id]}
                    className={`w-full border rounded-lg px-2 py-1.5 text-xs focus:outline-none focus:border-blue-400 ${
                      mapping[p.offer_id] ? 'border-green-300 bg-green-50 text-green-800' : 'border-gray-200 text-gray-500'
                    }`}
                  >
                    <option value="">— depo seç —</option>
                    {warehouses.map(w => (
                      <option key={w.warehouse_id} value={String(w.warehouse_id)}>{w.name}</option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={3} className="px-4 py-8 text-center text-gray-400 text-sm">Ürün bulunamadı</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
